import React, { useContext, useState } from "react";
import { InvestAccountContext } from "./contexts/InvestAccountContext";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { InvestCardComponent } from "./InvestCardComponent";
import AreYouSureModal from "../../../../components/modals/areYouSureModal";
import { Box, MenuItem, Select } from "@mui/material";

export const InvestmentAccounts = React.memo(() => {
    const { setInvestmentAccountModalOpen, investmentAccountModalOpen, accountSelected, setAccountSelected, chosenAccountAfterCommitment, familyMembers, trustDetails, entityId, setEntityId } = useContext(InvestAccountContext);
    const { user } = useContext(InvestTransactionContext);
    const [account, setAccount] = useState(accountSelected);
    const [newEntityId, setNewEntityId] = useState(entityId);

    console.log(accountSelected, "accountSelected");
    const handleSelectChange = (event) => {
        const newValue = event.target.value;
        setInvestmentAccountModalOpen(true);
        setAccount(newValue);
    };

    return (
        <>
            {(user?.isHufHead || familyMembers?.length > 0 || trustDetails?.length > 0) && (
                <InvestCardComponent title={"Select Account for Investment"}>
                    <AreYouSureModal
                        open={investmentAccountModalOpen}
                        setOpen={setInvestmentAccountModalOpen}
                        handleYes={() => {
                            setInvestmentAccountModalOpen(false);
                            setAccountSelected(account);
                            setEntityId(newEntityId);
                        }}
                        message={"Are You Sure About Changing investment Account for this Transaction?"}
                        note={"New investment Account is Only Applicable for This Specific Transaction."}
                        publicAddress={account + " Account"}
                        publicAddressMessage={"Your new selected account"}
                    />
                    <Box>
                        <Select
                            value={accountSelected}
                            disabled={chosenAccountAfterCommitment}
                            onChange={handleSelectChange}
                        >
                            <MenuItem value="Personal" onClick={() => {
                                setNewEntityId(null);
                            }}>Personal Account</MenuItem>
                            {user?.isHufHead && (
                                <MenuItem value="HUF" onClick={() => {
                                    setNewEntityId(user?.hufDetails[0]?._id);
                                }}>HUF Account</MenuItem>
                            )}
                            {familyMembers?.length > 0 &&
                                familyMembers.map((member, index) => (
                                    <MenuItem key={index} value={member.username} onClick={() => {
                                        setNewEntityId(member.familyMemberId);
                                    }}>
                                        {member.username} ({member.relation})
                                    </MenuItem>
                                ))
                            }
                            {(trustDetails?.length > 0 && trustDetails[0]?.trust?.status == "APPROVED") &&
                                <MenuItem value="Trust" onClick={() => {
                                    setNewEntityId(trustDetails[0]?.entityId);
                                }}>Trust Account</MenuItem>
                            }
                        </Select>
                    </Box>
                </InvestCardComponent>
            )}
        </>
    );
});